import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  padding-top: 16px;
`;
